import { CREDIT_CARD, DIRECT_DEBIT, INVOICE } from 'views/consts/payments'

export const mapResponseToComponentDataStructure = response => {
  const mappedPaymentMethodEntries = response.paymentMethods.map(entry => {
    const data = {
      id: entry.type,
      name: entry.name ?? entry.id,
      isDefault: entry.isDefault ?? false,
      changeHandler: () => {}
    }

    if (response.storedPaymentMethods) {
      const paymentDataEntriesForType = response.storedPaymentMethods.filter(
        dataSet => dataSet.type === entry.type
      )

      if (paymentDataEntriesForType.length) {
        data.paymentData = paymentDataEntriesForType.map(dataSet => {
          if (dataSet.type === CREDIT_CARD) {
            return {
              id: dataSet.id.toString(),
              isDefault: dataSet.isDefault ?? false,
              cardHolder: dataSet.holderName,
              cardNumber: dataSet.lastFour.toString(),
              cardExpiryMonth: dataSet.expiryMonth.toString().padStart(2, '0'),
              cardExpiryYear: dataSet.expiryYear.toString(),
              cardBrand: dataSet.brand
            }
          } else if (dataSet.type === DIRECT_DEBIT) {
            return {
              id: dataSet.id.toString(),
              isDefault: dataSet.isDefault ?? false,
              iban: dataSet.iban,
              owner: dataSet.ownerName
            }
          } else {
            return null
          }
        })
      }
    }

    return data
  })

  return {
    blockedPaymentMethods: response.blockedPaymentMethods,
    paymentMethodEntries: mappedPaymentMethodEntries,
    unavailableServices: response.unavailableServices
  }
}

export const singleCCPaymentDataSetIsDefault = {
  id: 'h7832hdzdg27gfd',
  isDefault: true,
  cardHolder: 'John Doe',
  cardNumber: '370000000000002',
  cardExpiryMonth: '03',
  cardExpiryYear: '2030',
  cardBrand: 'amex'
}

export const singleCCPaymentDataSetNotDefault = {
  id: '902jf2h8fh293fj2j',
  isDefault: false,
  cardHolder: 'Jane Doe',
  cardNumber: '4111111111111111',
  cardExpiryMonth: '03',
  cardExpiryYear: '2030',
  cardBrand: 'visa'
}

export const singleDBPaymentDataSet = {
  id: 'uhv479gh387hv',
  owner: 'John Doe',
  iban: 'DE06000000000023456789'
}

export const PaymentMethodMockDataFilled = {
  paymentMethodEntries: [
    {
      id: CREDIT_CARD,
      name: 'Kreditkarte',
      isDefault: true,
      paymentData: [
        singleCCPaymentDataSetIsDefault,
        singleCCPaymentDataSetNotDefault
      ],
      changeHandler: () => {}
    },
    {
      id: DIRECT_DEBIT,
      name: 'Lastschrift',
      isDefault: false,
      paymentData: [singleDBPaymentDataSet],
      changeHandler: () => {}
    },
    {
      id: INVOICE,
      name: 'Rechnung',
      expanded: true,
      changeHandler: () => {}
    }
  ]
}

export const PaymentMethodMockDataEmpty = {
  paymentMethodEntries: [
    {
      id: CREDIT_CARD,
      name: 'Kreditkarte',
      isDefault: false,
      paymentData: null,
      changeHandler: () => {}
    },
    {
      id: DIRECT_DEBIT,
      name: 'Lastschrift',
      isDefault: false,
      paymentData: null,
      changeHandler: () => {}
    }
  ]
}
